export const costOfLiving = [
  {
    category: 'Housing (Median Home)',
    roseville: '$585,000',
    california: '$750,000',
    national: '$420,000',
    trend: 'stable',
    icon: 'ri-home-4-line',
    source: 'Zillow Home Value Index 2024',
  },
  {
    category: 'Rent (2BR Apartment)',
    roseville: '$2,150/mo',
    california: '$2,600/mo',
    national: '$1,400/mo',
    trend: 'up',
    icon: 'ri-building-line',
    source: 'Rent.com & Apartments.com 2024',
  },
  {
    category: 'Groceries',
    roseville: '$380/mo',
    california: '$420/mo',
    national: '$340/mo',
    trend: 'stable',
    icon: 'ri-shopping-basket-line',
    source: 'USDA Food Cost Report 2024',
  },
  {
    category: 'Utilities',
    roseville: '$195/mo',
    california: '$230/mo',
    national: '$175/mo',
    trend: 'down',
    icon: 'ri-flashlight-line',
    source: 'Roseville Electric Utility & EIA',
  },
  {
    category: 'Transportation',
    roseville: '$140/mo',
    california: '$180/mo',
    national: '$120/mo',
    trend: 'stable',
    icon: 'ri-car-line',
    source: 'AAA Driving Costs 2024',
  },
  {
    category: 'Healthcare',
    roseville: '$520/mo',
    california: '$580/mo',
    national: '$470/mo',
    trend: 'up',
    icon: 'ri-heart-pulse-line',
    source: 'Kaiser Family Foundation 2024',
  },
];

export const neighborhoods = [
  {
    id: 1,
    name: 'West Roseville',
    tagline: 'Modern Family Living',
    description: 'Newest master-planned communities with top-rated schools, parks, and shopping. Perfect for growing families seeking brand-new homes and amenities.',
    image: 'https://public.readdy.ai/ai/img_res/30e3aa8019458e867b6e34eb21d1021f.jpg',
    medianPrice: '$620,000',
    walkScore: 42,
    schoolRating: '9/10',
    vibe: 'Family Friendly',
    highlights: ['Fiddyment Farm Park', 'Blue Oaks Town Center', 'New Construction Homes'],
  },
  {
    id: 2,
    name: 'Historic Old Town',
    tagline: 'Charming Downtown Character',
    description: 'The heart of Roseville with walkable streets, local boutiques, craft breweries, and a thriving arts scene. Ideal for those who love community and culture.',
    image: 'https://readdy.ai/api/search-image?query=Charming%20historic%20downtown%20main%20street%20with%20brick%20buildings%20outdoor%20cafes%20string%20lights%20boutique%20shops%20pedestrians%20walking%20warm%20evening%20light%20small%20town%20America%20California&width=600&height=400&seq=reloc2&orientation=landscape',
    medianPrice: '$485,000',
    walkScore: 78,
    schoolRating: '7/10',
    vibe: 'Urban Core',
    highlights: ['Vernon Street Town Square', 'Craft Breweries', 'Farmers Market'],
  },
  {
    id: 3,
    name: 'Granite Bay',
    tagline: 'Upscale Country Living',
    description: 'Prestigious area bordering Folsom Lake with large estate lots, equestrian properties, and access to world-class outdoor recreation.',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20estate%20homes%20near%20a%20lake%20with%20oak%20trees%20rolling%20hills%20California%20foothills%20upscale%20residential%20area%20golden%20sunset%20light%20spacious%20properties%20green%20landscaping&width=600&height=400&seq=reloc3&orientation=landscape',
    medianPrice: '$1,200,000',
    walkScore: 18,
    schoolRating: '10/10',
    vibe: 'Luxury Estate',
    highlights: ['Folsom Lake Access', 'Equestrian Trails', 'Top-Rated Schools'],
  },
  {
    id: 4,
    name: 'Sierra Vista',
    tagline: 'Established & Connected',
    description: 'Well-established neighborhood near Westfield Galleria with excellent freeway access, mature trees, and a strong sense of community.',
    image: 'https://readdy.ai/api/search-image?query=Established%20suburban%20neighborhood%20with%20mature%20oak%20trees%20well-maintained%20homes%20wide%20streets%20California%20suburb%20sunny%20day%20green%20lawns%20community%20feel%20warm%20tones&width=600&height=400&seq=reloc4&orientation=landscape',
    medianPrice: '$520,000',
    walkScore: 55,
    schoolRating: '8/10',
    vibe: 'Established',
    highlights: ['Westfield Galleria', 'Mahany Park', 'Easy I-80 Access'],
  },
  {
    id: 5,
    name: 'Sun City Roseville',
    tagline: 'Active Adult Community',
    description: 'Premier 55+ community with golf course, fitness center, pools, and over 100 clubs. Designed for active retirees seeking a vibrant social life.',
    image: 'https://readdy.ai/api/search-image?query=Active%20adult%20retirement%20community%20with%20golf%20course%20clubhouse%20swimming%20pool%20California%20sunshine%20well-manicured%20grounds%20seniors%20enjoying%20outdoor%20activities%20warm%20light&width=600&height=400&seq=reloc5&orientation=landscape',
    medianPrice: '$550,000',
    walkScore: 30,
    schoolRating: 'N/A',
    vibe: '55+ Community',
    highlights: ['18-Hole Golf Course', '7 Pools', '100+ Social Clubs'],
  },
  {
    id: 6,
    name: 'Woodcreek Oaks',
    tagline: 'Nature Meets Convenience',
    description: 'Beautiful tree-lined streets with creek trails, top schools, and quick access to shopping. A balanced lifestyle for families and professionals.',
    image: 'https://readdy.ai/api/search-image?query=Tree-lined%20residential%20street%20with%20creek%20trail%20running%20alongside%20homes%20California%20oak%20trees%20families%20walking%20dogs%20peaceful%20suburban%20setting%20dappled%20sunlight%20green%20nature&width=600&height=400&seq=reloc6&orientation=landscape',
    medianPrice: '$560,000',
    walkScore: 48,
    schoolRating: '9/10',
    vibe: 'Nature Lovers',
    highlights: ['Miners Ravine Trail', 'Woodcreek High School', 'Creek Parks'],
  },
];

export const schools = [
  {
    name: 'Roseville Joint Union High School District',
    type: 'High School',
    rating: 8,
    schools: ['Woodcreek High', 'Oakmont High', 'Roseville High', 'Granite Bay High', 'West Park High'],
    students: '11,500+',
    highlight: 'Granite Bay High ranked top 5% nationally',
    source: 'GreatSchools.org & U.S. News Rankings 2024',
  },
  {
    name: 'Roseville City School District',
    type: 'Elementary & Middle',
    rating: 8,
    schools: ['Cirby Elementary', 'Crestmont Elementary', 'Buljan Middle', 'Cooley Middle'],
    students: '11,200+',
    highlight: 'Award-winning STEM programs',
    source: 'California Dept. of Education 2024',
  },
  {
    name: 'Eureka Union School District',
    type: 'K-8',
    rating: 9,
    schools: ['Excelsior Elementary', 'Ridgeview Elementary', 'Olympus Middle'],
    students: '4,800+',
    highlight: 'Consistently top-performing in Placer County',
    source: 'GreatSchools.org 2024',
  },
  {
    name: 'Sierra College',
    type: 'Community College',
    rating: 9,
    schools: ['Main Campus - Rocklin'],
    students: '18,000+',
    highlight: 'Top transfer rates to UC and CSU systems',
    source: 'Sierra College Official Data 2024',
  },
];

export const utilityProviders = [
  {
    category: 'Electricity',
    provider: 'Roseville Electric Utility',
    phone: '(916) 774-5300',
    website: 'roseville.ca.us/electric',
    setupTime: '1-2 business days',
    icon: 'ri-flashlight-line',
    color: '#F59E0B',
    tip: 'Roseville has some of the lowest electric rates in California — city-owned utility!',
  },
  {
    category: 'Water & Sewer',
    provider: 'City of Roseville Environmental Utilities',
    phone: '(916) 774-5750',
    website: 'roseville.ca.us/eu',
    setupTime: '1-2 business days',
    icon: 'ri-drop-line',
    color: '#3B82F6',
    tip: 'Water is included in your utility bill along with sewer and garbage services.',
  },
  {
    category: 'Natural Gas',
    provider: 'PG&E (Pacific Gas & Electric)',
    phone: '1-800-743-5000',
    website: 'pge.com',
    setupTime: '2-3 business days',
    icon: 'ri-fire-line',
    color: '#EF4444',
    tip: 'Set up your PG&E account online for fastest activation.',
  },
  {
    category: 'Internet & Cable',
    provider: 'Multiple Options Available',
    phone: '',
    website: '',
    setupTime: '3-5 business days',
    icon: 'ri-wifi-line',
    color: '#8B5CF6',
    tip: 'Xfinity, AT&T Fiber, and T-Mobile Home Internet all serve Roseville.',
    options: [
      { name: 'Xfinity', speed: 'Up to 1.2 Gbps', price: 'From $35/mo' },
      { name: 'AT&T Fiber', speed: 'Up to 5 Gbps', price: 'From $55/mo' },
      { name: 'T-Mobile 5G', speed: 'Up to 245 Mbps', price: 'From $50/mo' },
    ],
  },
  {
    category: 'Trash & Recycling',
    provider: 'City of Roseville Environmental Utilities',
    phone: '(916) 774-5780',
    website: 'roseville.ca.us/recycle',
    setupTime: 'Included with water service',
    icon: 'ri-recycle-line',
    color: '#10B981',
    tip: 'Three-bin system: green (yard waste), blue (recycling), gray (trash).',
  },
];

export const dmvChecklist = [
  {
    step: 1,
    title: 'Get California Driver\'s License',
    deadline: 'Within 10 days of establishing residency',
    documents: ['Out-of-state license', 'Proof of CA residency (2 documents)', 'Social Security card', 'Passport or birth certificate'],
    fee: '$41',
    tip: 'Book your DMV appointment online at dmv.ca.gov — walk-ins can have 2+ hour waits.',
    icon: 'ri-id-card-line',
  },
  {
    step: 2,
    title: 'Register Your Vehicle',
    deadline: 'Within 20 days of establishing residency',
    documents: ['Out-of-state title', 'Out-of-state registration', 'Smog certificate', 'Proof of insurance'],
    fee: '$60-$200+',
    tip: 'Get your smog check done first — many shops on Sunrise Ave offer quick service.',
    icon: 'ri-car-line',
  },
  {
    step: 3,
    title: 'Update Voter Registration',
    deadline: 'At least 15 days before next election',
    documents: ['CA driver\'s license or SSN'],
    fee: 'Free',
    tip: 'Register online at registertovote.ca.gov — takes less than 5 minutes.',
    icon: 'ri-government-line',
  },
  {
    step: 4,
    title: 'Get a Library Card',
    deadline: 'Anytime',
    documents: ['Photo ID', 'Proof of Roseville address'],
    fee: 'Free',
    tip: 'Roseville Public Library has 3 branches and an amazing digital collection.',
    icon: 'ri-book-open-line',
  },
];

export const localTips = [
  {
    category: 'Dining',
    tip: 'The Roseville Farmers Market runs every Saturday morning at the Fountains. Get there early for the best organic produce and artisan bread.',
    author: 'Sarah M.',
    since: 2018,
    icon: 'ri-restaurant-line',
  },
  {
    category: 'Shopping',
    tip: 'Skip the Galleria on weekends if you can. Tuesday and Wednesday evenings are the sweet spot — same stores, zero crowds.',
    author: 'Mike T.',
    since: 2015,
    icon: 'ri-shopping-bag-line',
  },
  {
    category: 'Outdoors',
    tip: 'Miners Ravine Trail is the hidden gem of Roseville. 10+ miles of paved trail perfect for biking, running, or a peaceful walk along the creek.',
    author: 'Jennifer L.',
    since: 2020,
    icon: 'ri-run-line',
  },
  {
    category: 'Community',
    tip: 'Join Nextdoor and the Roseville Community Facebook group immediately. Best way to find recommendations, meet neighbors, and stay in the loop.',
    author: 'David K.',
    since: 2017,
    icon: 'ri-group-line',
  },
  {
    category: 'Weather',
    tip: 'Summers are hot (100°F+) but dry. Invest in good window shades and hit the Roseville Aquatics Complex — it\'s world-class and affordable.',
    author: 'Amanda R.',
    since: 2019,
    icon: 'ri-sun-line',
  },
  {
    category: 'Getting Around',
    tip: 'Douglas Blvd and Cirby Way are your main east-west arteries. Avoid I-80 during 7-9 AM and 4-6 PM commute hours — take surface streets instead.',
    author: 'Chris P.',
    since: 2016,
    icon: 'ri-road-map-line',
  },
  {
    category: 'Family',
    tip: 'Roseville Parks & Rec has incredible youth programs. Sign up the day registration opens — popular classes fill up within hours.',
    author: 'Lisa W.',
    since: 2021,
    icon: 'ri-parent-line',
  },
  {
    category: 'Healthcare',
    tip: 'Sutter Roseville Medical Center is one of the best hospitals in the region. Kaiser also has a large facility on Eureka Road.',
    author: 'Robert H.',
    since: 2014,
    icon: 'ri-hospital-line',
  },
];

export const quickFacts = [
  { label: 'Population', value: '147,000+', icon: 'ri-group-line', source: 'U.S. Census Bureau 2024' },
  { label: 'Median Household Income', value: '$95,400', icon: 'ri-money-dollar-circle-line', source: 'U.S. Census ACS 2024' },
  { label: 'Sunny Days Per Year', value: '269', icon: 'ri-sun-line', source: 'U.S. Climate Data' },
  { label: 'Parks & Open Spaces', value: '80+', icon: 'ri-plant-line', source: 'City of Roseville Parks Dept.' },
  { label: 'Miles of Trails', value: '42', icon: 'ri-route-line', source: 'Roseville Parks & Recreation' },
  { label: 'Drive to Lake Tahoe', value: '90 min', icon: 'ri-car-line', source: 'Google Maps' },
];
